import { render } from "./TextSort.vue?vue&type=template&id=c54bbe2a&scoped=true"
import script from "./TextSort.vue?vue&type=script&lang=js"
export * from "./TextSort.vue?vue&type=script&lang=js"

import "./TextSort.vue?vue&type=style&index=0&id=c54bbe2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54bbe2a"]])

export default __exports__